module.exports = __webpack_public_path__ + "img/Poederlijst.0892321a.svg";